<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="dedication"><a id="page_vii"></a><em>For my dad, Jim Van Fleet<br/>1948–1994</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?81487e12